import Theme from 'Theme';
import { useURLSearchParams } from 'hooks/useURLSearchParams';
import { AppContainer } from 'pages/client/client.styles';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchConfigStartAsync } from 'redux/config/config.actions';
import PreviewHeader from './preview-header.component';

const CommunicationsPreview = ({ children }) => {
  const dispatch = useDispatch();
  const [isLoaded, setIsLoaded] = useState(false);
  const query = useURLSearchParams();

  useEffect(() => {
    const execute = async () => {
      await dispatch(fetchConfigStartAsync(query.get('clientId')));
      setIsLoaded(true);
    };

    execute();
  }, [dispatch, query]);

  if (!isLoaded) return null;

  return (
    <Theme>
      <PreviewHeader />
      <AppContainer>{children}</AppContainer>
    </Theme>
  );
};
export default CommunicationsPreview;
